import {
    ContainerAvailabilityAllowedProductTypes,
} from 'app/enums/label.enums'
import {
    ForecastsByProduct,
} from '../../serviceCenters.types'

export type ProcessedContainersByProductRow = {
    productType: 'ALL' | ContainerAvailabilityAllowedProductTypes,
    id: string,
    [key: string]: number | string,
}

export type ProcessedContainerByProductsConfig = {
    columns: Set<string>,
    data: ProcessedContainersByProductRow[]
}

// eslint-disable-next-line import/prefer-default-export
export const parseForecastsByProductForInProcess = (
    data: ForecastsByProduct[],
): ProcessedContainerByProductsConfig => {
    const columns = new Set<string>()
    const parsedData = []

    data.forEach(({
        productType, forecast,
    }) => {
        const row = {
            productType,
            id: productType,
        }

        forecast.forEach(({
            date, inProcess,
        }) => {
            columns.add(date)
            row[date] = inProcess
        })

        parsedData.push(row)
    })

    return {
        columns,
        data: parsedData,
    }
}
